<template>
  <vx-card :title="item.title" subtitle="Data disajikan dalam periode tahun" class="mb-base">
    <!-- Actions -->
    <template slot="actions">
      <dropdown-year v-model="selectedYear" :years="years"></dropdown-year>
    </template>

    <!-- Chart -->
    <template slot="no-body">
      <div class="my-10">
        <vue-apex-charts
          type="radialBar"
          height="300"
          :options="chartOptions"
          :series="series">
        </vue-apex-charts>
      </div>
    </template>

    <!-- Details -->
    <div class="flex flex-col md:flex-row justify-between text-center" slot="no-body-bottom">
      <div class="w-auto sm:w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
          <p class="mt-4">Target Tahun {{selectedYear}}</p>
          <p class="mb-4 text-1xl font-semibold">Rp. {{ chartData.target | commas}}</p>
      </div>
      <div class="w-auto sm:w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
          <p class="mt-4">Realisasi Tahun {{selectedYear}}</p>
          <p class="mb-4 text-1xl font-semibold">Rp. {{ chartData.realization | commas }}</p>
      </div>
    </div>
  </vx-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import DropdownYear from '@/components/DropdownYear.vue'

export default {
  components: {
    VueApexCharts,
    DropdownYear
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedYear: this.item.defaultYear,
      chartData: {
        value: 0,
        target: 0
      },
      years: [2020,2021]
    }
  },
  computed: {
    series() {
      let val = parseFloat((this.chartData.realization / this.chartData.target) * 100).toFixed(0)
      return [
        isNaN(val) ? 0 : val 
      ]
    },
    chartOptions(){
      return this.setChartOptions();
    }
  },
  watch: {
    selectedYear: {
      handler() {
        this.loadSeries()
      }
    }
  },
  mounted() {
    this.loadSeries();
    this.loadYears();
  },
  methods: {
    async loadSeries() {
      const res = await this.$http.get('/realization/by-year-data', {
        params: {
          type: this.item.type,
          year: this.selectedYear
        }
      })
      this.chartData = res.data.data;
    },
    async loadYears(){
      const res = await this.$http.get('/realization/year-data', {
        params: {
          type: this.item.type
        }
      })
      let data = res.data.data;
      this.years = data;
    },
    setChartOptions(){
      var self = this;
      return {
        plotOptions: {
        radialBar: {
          size: 150,
          startAngle: -150,
          endAngle: 150,
          hollow: {
            size: '77%'
          },
          track: {
            background: '#bfc5cc',
            strokeWidth: '50%'
          },
          dataLabels: {
            name: {
              show: false
            },
            value: {
              offsetY: 18,
              color: '#99a2ac',
              fontSize: '4rem'
            }
          },
          }
        },
        colors: [self.item.realization.color],
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: [self.item.target.color],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: 'round'
        },
        chart: {
          sparkline: {
            enabled: true
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1
          }
        }
      }
    }
  }
}
</script>